import "@/styles/atlas.css";
import "@/styles/atlas-extra.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Home from "@/pages/Home";
import Categories from "@/pages/Categories";
import CategoryDetail from "@/pages/CategoryDetail";
import Services from "@/pages/Services";
import Tours from "@/pages/Tours";
import Guides from "@/pages/Guides";
import Risks from "@/pages/Risks";
import GuideDetail from "@/pages/GuideDetail";
import MyLibrary from "@/pages/MyLibrary";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Checkout from "@/pages/Checkout";
import PaymentResult from "@/pages/PaymentResult";
import Result from "@/pages/Result";
import Legal from "@/pages/Legal";
import Admin from "@/admin/Admin";
import Search from "@/pages/Search";
import ThemeStyle from "@/components/site/ThemeStyle";
import AnalyticsPageTracker from "@/components/site/AnalyticsPageTracker";

export default function App() {
  return (
    <BrowserRouter>
      <ThemeStyle />
      <AnalyticsPageTracker />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/categories" element={<Categories />} />
        <Route path="/categories/:slug" element={<CategoryDetail />} />
        <Route path="/services" element={<Services />} />
        <Route path="/tours" element={<Tours />} />
        <Route path="/guides" element={<Guides />} />
        <Route path="/guides/my-library" element={<MyLibrary />} />
        <Route path="/risks" element={<Risks />} />
        <Route path="/search" element={<Search />} />
        <Route path="/guides/:slug" element={<GuideDetail />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/checkout/:kind/:id" element={<Checkout />} />
        <Route path="/payment/success" element={<PaymentResult ok />} />
        <Route path="/payment/cancel" element={<PaymentResult ok={false} />} />
        <Route path="/booking-confirmed" element={<Result ok />} />
        <Route path="/payment-failed" element={<Result ok={false} />} />
        <Route path="/refund-policy" element={<Legal type="refund-policy" />} />
        <Route path="/privacy" element={<Legal type="privacy" />} />
        <Route path="/terms" element={<Legal type="terms" />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
